import {useMemo} from "react"
import {useQuery} from "react-query"
import {API} from "API"
import {isEmpty} from "utils"

export default function useOpenCourses() {

    const query = useQuery(
        ["open-courses"],
        () => API.coursesOpenGet().then(response => response.data)
    )

    // Courses one can apply for; undefined until loaded
    const selectCourses = useMemo(() => {
        return query.data?.filter(course => course.open ?? true).filter(course => isEmpty(course.previous))
    }, [query.data])

    const getCourse = (courseId) => {
        if (!query.data) return null
        for (const course of query.data)
            if (course.id === courseId)
                return course
        return null       
    }
    
    const getPrice = (course) => {
        return course.instalments.reduce((acc, currentValue) => acc + currentValue, 0)
    }
    
    const getNext = (courseId) => {
        if (!query.data) return null
        for (const course of query.data)
            if (course.previous === courseId)
                return course
        return null     
    }

    return {...query, selectCourses, getCourse, getNext, getPrice}
    
}